<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>SOCIAL</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
          <span v-for="(social,lindex) in SocialData" :key="lindex">
               <div>
                 <vs-input :label="social.name" v-model="social.link" class="w-full mb-base mb-base"></vs-input>
               </div>
          </span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button> -->
      <vs-button type="border" color="primary" @click.native="isSidebarActiveLocal = false">Done</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_SOCIAL_TEMP,SAVE_SOCIAL_DRAFT,SAVE_SOCIAL_SECTION} from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      SocialData:[
              {
                "name":"Facebook",
                "link":"https://www.facebook.com/AdvantageELC/",
                 "icon":"fab fa-facebook-f"
              },
              {
                "name":"Twitter",
                "link":"",
                "icon":"fab fa-twitter"
              },
              {
                "name":"Youtube",
                "link":"",
                "icon":"fab fa-youtube"
              },
               {
                "name":"Instagram",
                "link":"",
                "icon":"fab fa-instagram"
              },
               {
                "name":"Pinterest",
                "link":"",
                "icon":"fab fa-pinterest"
              },
               {
                "name":"LinkedIn",
                "link":"",
                "icon":"fab fa-linkedIn"
              },
               {
                "name":"Yelp",
                "link":"",
                "icon":"fab fa-yelp"
              },
               {
                "name":"Houzz",
                "link":"",
                "icon":"fab fa-houzz"
              },
               {
                "name":"Discord",
                "link":"",
                "icon":"fab fa-discord"
              },
               {
                "name":"Twitch",
                "link":"",
                "icon":"fab fa-twitch"
              }
          ]
    }
  },
  watch: {
    SocialData: {
      handler(val, oldVal) {
        var SocialData=val
        var html=null
        var sec = makeSocial(SocialData,html)
        this.$emit('setSocial',sec)

            function makeSocial(SocialData,html){
            
            html = `<ul kvsb-data="sb-socialicon" class="social-icon-colored sb-socialicon">`;
                  SocialData.forEach(data => { 
                    if(data.link && data.link.length>0){
                       html +=` <li><a href="${data.name}" target="_blank"><span class="${data.icon}"></span></a></li>`
                    }
            });
            html +=`</ul>`;
            return html;
            }
         var social_file = {"SocialData":val}  
         console.log(JSON.stringify(social_file))
         this.SaveSocialFile(JSON.stringify(social_file))
         this.SaveSocilaSection(sec)
        // if(this.menu_temp && this.menuData){
        //     var menuData=val
        //     var html=null
        //     eval(this.menu_temp);
        //     // console.log(html)
        //     this.createMenu(html)
        //     this.$emit('setMenuData',val)

        //   }
          

        //  this.$emit("setMenu", html);
      },
      deep: true,
    },
    isSidebarActive (val) {

    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
      SaveSocilaSection(data){
       const site = this.$route.params.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_SOCIAL_SECTION,
            variables: {
               site: site,
               data:data
            },
          })
          .then((response) => {

          })
          .catch((error) => {
            console.log(error);
          });
    },

    initValues () {
 
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
 




        }
      })
    },
    SaveSocialFile(data){
       const site =this.$route.params.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_SOCIAL_DRAFT,
            variables: {
              site: site,
              social:data
            },
          })
          .then((response) => {

          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  created(){
        this.$apollo
        .mutate({
          mutation: GET_SOCIAL_TEMP,
           variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
          // //  this.menu_temp = response.data.getMenuTemp.menu_temp
           this.SocailData=JSON.parse(response.data.getSocialTemp.menu_data).SocialData
          //  console.log(this.menuData)
        })
        .catch((error) => {
          console.log(error);
        });
    
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
